import { render, staticRenderFns } from "./CreateManyForm.vue?vue&type=template&id=48eeb21e&scoped=true&"
import script from "./CreateManyForm.vue?vue&type=script&lang=js&"
export * from "./CreateManyForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateManyForm.vue?vue&type=style&index=0&id=48eeb21e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eeb21e",
  null
  
)

export default component.exports